import { api } from './client.js';

export const listProjects   = ()         => api.get('/projects');
export const getProject     = (id)       => api.get(`/projects/${id}`);
export const createProject  = (payload)  => api.post('/projects', payload);
export const updateProject  = (id, body) => api.put(`/projects/${id}`, body);
export const deleteProject  = (id)       => api.del(`/projects/${id}`);

// Sharing
export const listProjectShares  = (id)              => api.get(`/projects/${id}/shares`);
export const addProjectShare    = (id, email, role) => api.post(`/projects/${id}/shares`, { email, role });
export const removeProjectShare = (id, userId)      => api.del(`/projects/${id}/shares/${userId}`);
